import App from './App';
import React from 'react';
import './styles/main.css';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom/client';
import store, { persistor } from 'appState/store';
import { PersistGate } from 'redux-persist/integration/react';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>

);
